import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib';
import { createSlice } from '@reduxjs/toolkit';

export const surveysUiSlice = createSlice({
  name: 'surveys-ui',
  initialState: baseUiInitialState,
  reducers: {
    ...baseUiReducers,
  },
});
